module.exports = __webpack_public_path__ + "img/05.d0d52bcc.jpg";